module.exports = ".selectedItem {\r\n    background: #FFFFFF50;\r\n}\r\n.selectedItemColor {\r\n    color: white !important;\r\n    /* More Text with .... */\r\n    white-space: nowrap;\r\n    width: 190px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n.callout-info {\r\n    border-color: #FFCA28 !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/license-sidenav/license-sidenav.component.css
// module id = 971
// module chunks = 1